import React, { useState } from 'react';
import { DatePicker, Segmented } from 'antd';
import EventDateTimePicker from 'components/EventDateTimePicker';
import EventTimezoneNote from 'components/EventTimezoneNote';
import {
	PAST_NOTE,
	SCHEDULE,
	applyMode,
	oneDayRange,
	scheduleDay,
	scheduleMode,
	scheduleSentence,
	toIsoOrNull,
} from './checklistSchedule';

const MODES = [
	{ label: 'Always', value: SCHEDULE.ALWAYS },
	{ label: 'One day', value: SCHEDULE.DAY },
	{ label: 'Date range', value: SCHEDULE.RANGE },
];

const SectionSchedule = ({ event, section, onChange }) => {
	// Date range with no times set looks like Always, so the chosen mode lives here.
	const [mode, setMode] = useState(() => scheduleMode(event, section));
	const pickMode = next => {
		setMode(next);
		onChange(applyMode(event, section, next));
	};

	return (
		<div className="ChecklistEditor-schedule">
			<Segmented options={MODES} value={mode} onChange={pickMode} />
			{mode === SCHEDULE.DAY && (
				<DatePicker
					allowClear={false}
					format="ddd, MMM D, YYYY"
					value={scheduleDay(event, section)}
					onChange={date => onChange(oneDayRange(event, date))}
				/>
			)}
			{mode === SCHEDULE.RANGE && (
				<div className="ChecklistEditor-schedule-range">
					<label>
						<span>Shows up</span>
						<EventDateTimePicker
							event={event}
							value={section.appears_at}
							onChange={value => onChange({ appears_at: toIsoOrNull(value) })}
						/>
					</label>
					<label>
						<span>Moves to past sections</span>
						<EventDateTimePicker
							event={event}
							value={section.current_until}
							onChange={value => onChange({ current_until: toIsoOrNull(value) })}
						/>
					</label>
				</div>
			)}
			<EventTimezoneNote event={event} referenceDate={section.appears_at} />
			<p className="ChecklistEditor-schedule-sentence">
				{scheduleSentence(event, section)}
				{section.current_until && <span> {PAST_NOTE}</span>}
			</p>
		</div>
	);
};

export default SectionSchedule;
